module.exports = __webpack_public_path__ + "img/-e-photo_05@2x.ec00d2d1.png";